import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from 'axios';
import store from '@/store';
import { ElMessage, ElLoading } from 'element-plus';
export default function download(config) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'application/vnd.ms-excel;charset=UTF-8' : _ref$type,
    _ref$fileType = _ref.fileType,
    fileType = _ref$fileType === void 0 ? '.zip' : _ref$fileType,
    _ref$fileName = _ref.fileName,
    fileName = _ref$fileName === void 0 ? '' : _ref$fileName,
    _ref$exportTypr = _ref.exportTypr,
    exportTypr = _ref$exportTypr === void 0 ? '导出' : _ref$exportTypr,
    _ref$declarationType = _ref.declarationType,
    declarationType = _ref$declarationType === void 0 ? '' : _ref$declarationType;
  var loading = ElLoading.service({
    lock: true,
    text: '请稍等...',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  return new Promise(function (resolve) {
    axios(_objectSpread(_objectSpread({}, config), {}, {
      baseURL: process.env.VUE_APP_BASE_API,
      headers: {
        Authorization: store.getters.token
      },
      responseType: 'blob'
    })).then(function (response) {
      loading.close();
      var res = response.data;
      if (res.type === 'application/json') {
        var reader = new FileReader();
        reader.onload = function (event) {
          var dit = JSON.parse(reader.result);
          ElMessage({
            message: dit.message,
            grouping: true
          });
          loading.close();
          if (dit.code === 401) {
            store.dispatch('user/LOGOUT').then(function () {
              location.reload();
            });
          }
        };
        reader.readAsText(res);
      } else {
        var blob = new Blob([res], {
          type: type
        });
        if (fileName === undefined || fileName === '') {
          var nameFront = declarationType ? "Cat ".concat(declarationType, " ") : '';
          fileName = "".concat(nameFront, "declaration-").concat(new Date().format('MMdd-hhmm'));
        }
        if (window.navigator.msSaveBlob) {
          // IE以及IE内核的浏览器
          try {
            console.log('fileType:', fileType);
            // window.navigator.msSaveBlob(blob, fileName)	// response为接口返回数据，这里请求的时候已经处理了，如果没处理需要在此之前自行处理var data = new Blob([response.data]) 注意这里需要是数组形式的,fileNm就是下载之后的文件名
            window.navigator.msSaveOrOpenBlob(blob, fileName + fileType); // 此方法类似上面的方法，区别可自行百度
          } catch (e) {
            console.log(e);
          }
        } else {
          var href = URL.createObjectURL(blob);
          var downloadElement = document.createElement('a');
          downloadElement.href = href;
          downloadElement.download = fileName + fileType;
          document.body.appendChild(downloadElement);
          downloadElement.click();
          URL.revokeObjectURL(downloadElement.href);
          document.body.removeChild(downloadElement);
        }
        ElMessage({
          message: exportTypr + '成功',
          grouping: true
        });
        resolve(response);
      }
    }).catch(function (e) {
      ElMessage({
        message: '下载超时，请减少勾选报关单数量后再尝试下载',
        grouping: true
      });
      loading.close();
    });
  });
}